import * as Types from '../constants/actionTypes';

export default (state = { packagingData: [] }, action) => {
  //console.log(`state in auth is :`,state);
  switch (action.type) {
    case Types.PACKAGING_LIST_PAGINATE:
      return {
        ...state,
        allPackagingData: action.packagingData
      }
    case Types.PACKAGING_ERROR:
      return {
        ...state,
        packingError: action.packingError
      }
    case Types.ADD_PACKAGING:
      state.packagingData.push(action.addPackData)
      return {
        ...state,
      }
      case Types.PACKING_SERVICES_INFORMATION:
      return {
        ...state,
        packingServices: action.packingServices
      }
    case Types.UPDATE_PACKAGING:
      const packagingData = state.packagingData;

      packagingData[action.pIndex] = action.updatePackData
      return {
        ...state,
        packagingData: packagingData
      }

    case Types.DELETE_PACKAGING:
      const newList = state.packagingData.filter((packaging) => packaging.id !== action.payload)
      return {
        ...state,
        packagingData: newList,
        deletedStatus: action.payload
      }
    case Types.PACKAGING_DETAIL_SUCCESS:
      return {
        ...state,
        packagingData: action.payload
      }
    case Types.PACKAGING_SUCCESS:
      return {
        ...state,
        packagingList: action.packagingList
      }
      case Types.DIMENSIONS_LIST:
      return {
        ...state,
        dimensionsList: action.dimensionsList
      }
      case Types.DELETE_DIMENSIONS:
      const newData = state.dimensionsList.filter((packaging) => packaging.id !== action.payload)
      return {
        ...state,
        dimensionsList: newData,
        deletedStatus: action.payload
      }
    case Types.PACKAGING_INFO_COUNT_SUCCESS:
      return Object.assign({}, state, { packagingInfoCount: action.payload })
    default:
      return state;
  }
};